export default {
  restaurante: null,
  restauranteObj: null,
  productos: [],
  categorias: [],
  descuentos: []
}